import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react'
import { Button, Checkbox, Icon, List, Pagination } from 'semantic-ui-react'
import {
  getShipmentDocuments,
  getDocumentsType,
  getSignedUrls,
  uploadDcoumentToHRMC,
  getStatus,
} from '../../../../commonApis/getGBForm'
import { groupDocumentsByType } from '../../util/groupDocuments'
import RenderDocumentsList from './renderDocumentsList'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { showToast } from '../../../commonComponents/showToast'
import HiistoryDetails from './historyDetails'
import CustomPopup from '../../../commonComponents/customPopup'
import ZoomSlider from './ZoomSlider'

const colorCode = {
  SUCCESS: '#009900',
  FAILED: '#ff6666',
  UPLOADED: '#00cc00',
  SCHEDULED: '#ffcc00',
  REJECTED: '#ff3333',
}

const listOfDocuments = ({ onClose }) => {
  const isFirstDocument = useRef(true)
  const historyPopup = useRef()
  const [isLoading, setIsLoading] = useState(true)
  const [documentList, setDocumentList] = useState({})
  const [docTypes, setDocTypes] = useState([])
  const [selectedDoc, setSelectedDoc] = useState()
  const [selectedDocuments, setSelectedDocuments] = useState([])
  const [documentForPDFReview, setDocumentForPDFReview] = useState({})
  const [page, setPage] = useState(1)
  const [isUploading, setIsUploading] = useState(false)
  const [statusOfDocument, setStatusOfDocument] = useState([])
  const [message, setMessage] = useState('')
  const [isCheckAll, setIsCheckAll] = useState(false)
  const [minScaleValue, setMinScaleValue] = useState(1)
  const [scaleValue, SetScaleValue] = useState(1)

  const getShipmentDocumentsHelper = async () => {
    let response = await getShipmentDocuments(window.shipmentId)
    if (response.data.eventMessage.message) {
      setIsLoading(false)
      setMessage(response.data.eventMessage.message)
    } else {
      let response1 = await getDocumentsType()
      const docTypes = response1.data.eventMessage.docTypes
      setDocTypes(docTypes)
      let documentList = response.data.eventMessage.documents
      let imageList = []
      for (let onedoc of documentList) {
        imageList.push(onedoc.remoteurl.split('/').pop()) //only get the last part of the url
      }
      let responseImageList = await getSignedUrls({ files: imageList })
      let imageListURLS = responseImageList.data.eventMessage.urls
      let imageIndex = 0
      for (let onedoc of documentList) {
        onedoc.image = imageListURLS[imageIndex]
        imageIndex++
      }
      let groupedDocs = groupDocumentsByType(documentList)
      groupedDocs = Object.fromEntries(groupedDocs)
      setDocumentList(groupedDocs)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getShipmentDocumentsHelper()
  }, [])

  useEffect(() => {
    let timer = setInterval(async () => {
      const response = await getStatus(window.shipmentId)
      setStatusOfDocument(response.data.eventMessage.fileUpload || [])
      //  console.log({response})
    }, 5000)

    return () => clearInterval(timer)
  })

  const FolderList = React.memo(({ renderItem, documentList }) => {
    const data = Object.keys(documentList)
    return data.map((folder, index) => renderItem(folder, index))
  })

  const rednerFolders = (folder, index) => {
    return (
      <RenderDocumentsList
        key={folder + 'bbbb' + index}
        folderData={documentList[folder]}
        // docsNames={docsNames}
        folder={folder}
        docTypes={docTypes}
        renderItem={renderFiles}
      />
    )
  }

  const handleForPreview = (data, name) => {
    setPage(1)
    setSelectedDoc(name)
    const images = []
    data.forEach((item) => {
      images.push(item.image)
    })
    setDocumentForPDFReview(images)
  }

  const handleCheckbox = (checked, value, name, version) => {
    if (checked) {
      setSelectedDocuments([
        ...selectedDocuments,
        { documentId: value, documentName: name, version },
      ])
    } else {
      if (isCheckAll) setIsCheckAll(false)
      setSelectedDocuments([...selectedDocuments.filter((doc) => doc.documentId != value)])
    }
  }

  const uploadDocument = async (e) => {
    e.currentTarget.disabled = true
    setIsUploading(true)
    const response = await uploadDcoumentToHRMC(selectedDocuments)
    if (response) {
      setIsUploading(false)
      setSelectedDocuments([])
      setIsCheckAll(false)
      showToast(response.data.eventMessage.msg, undefined, 'fileUploadError')
    }
  }

  const handleCheckAll = (checked) => {
    setIsCheckAll(checked)
    if (checked) {
      const data = Object.keys(documentList)
      data.forEach((folder) => {
        let folderData = documentList[folder]
        let { documents } = folderData
        let parentDocIds = Array.from(documents.keys())
        parentDocIds.forEach((parentDoc, index) => {
          let docs = documents.get(parentDoc)
          setSelectedDocuments((prevValue) => [
            ...prevValue,
            {
              documentId: docs?.[0]?.docid,
              documentName: `${folder}-${index + 1}`,
              version: docs?.[0]?.version,
            },
          ])
        })
      })
    } else {
      setSelectedDocuments([])
    }
  }

  const scaleChange = (value) => {
    if (value < minScaleValue) {
      SetScaleValue(1)
    } else {
      SetScaleValue(value)
    }
  }

  const renderFiles = (name, data) => {
    let version = data?.[0].version
    let docid = data?.[0]?.docid
    let docStatus = statusOfDocument?.find((item) => item.documentId === docid)

    if (isFirstDocument.current) {
      const images = []
      data.forEach((item) => {
        images.push(item.image)
      })
      setDocumentForPDFReview(images)
      setSelectedDoc(name)
      isFirstDocument.current = false
    }
    return (
      <div
        id={name}
        className={selectedDoc === name ? `listView selectedDoc` : `listView documentOptions`}
        onClick={() => handleForPreview(data, name)}
      >
        <List.Header>
          <Checkbox
            checked={selectedDocuments?.some((item) => item.documentId === data?.[0]?.docid)}
            name='selectedDocuments'
            value={data?.[0]?.docid}
            onChange={(e, { checked, value }) => {
              e.stopPropagation()
              handleCheckbox(checked, value, name, version)
            }}
            label={name}
          />
        </List.Header>
        <List.Description>
          Pages: {data?.length}, Status:
          <span style={{ color: `${colorCode[docStatus?.status]}` }}>
            {docStatus?.status ? docStatus?.status : 'N/A'}
          </span>
        </List.Description>
      </div>
    )
  }

  return (
    <>
      <div className='fileUploadError toast'></div>
      <div>
        <h2 style={{ display: 'inline-block' }}>File Upload to HMRC</h2>

        <Button
          color='blue'
          floated='right'
          disabled={isLoading}
          onClick={() => {
            historyPopup.current?.openPopup()
          }}
        >
          View History
        </Button>
       
        <Button
          basic
          color='blue'
          floated='right'
          style={{marginRight:'20px'}}
          onClick={() => {
             window.open(`https://www.tax.service.gov.uk/cds-file-upload-service/start`)       
          }}
        >
         Upload Via Web
        </Button>
       
        <CustomPopup
          content={true}
          description={<HiistoryDetails onClose={historyPopup.current?.closePopup} />}
          ref={historyPopup}
          className='fileUploadHistoryPopup'
        />
      </div>
      {isLoading && <CustomLoader style={{ marginTop: '0 20px' }}>Please Wait...</CustomLoader>}
      {message && (
        <div>
          <p>{message}</p>
          <Button floated='left' color='blue' style={{ marginTop: '30px' }} onClick={onClose}>
            Close
          </Button>
        </div>
      )}

      {!isLoading && !message && (
        <>
          <div>
            <Checkbox
              checked={isCheckAll}
              onChange={(e, { checked }) => handleCheckAll(checked)}
              label='CHECK ALL'
            />
          </div>
          <div className='parentDiv'>
            <div className='documentList'>
              <div>
                <div className='force-scrollbar renderList'>
                  <List>
                    <FolderList renderItem={rednerFolders} documentList={documentList} />
                  </List>
                </div>
              </div>

              <Button floated='left' color='blue' style={{ marginTop: '30px' }} onClick={onClose}>
                Close
              </Button>

              <Button
                floated='right'
                color='blue'
                style={{ marginTop: '30px' }}
                disabled={!selectedDocuments?.length}
                onClick={uploadDocument}
              >
                {isUploading && <CustomLoader inline size='mini' />}
                &nbsp; Send to NCH
              </Button>
            </div>
            <div className='zoom-buttons'>
              <ZoomSlider
                scaleValue={scaleValue}
                scaleChange={scaleChange}
                minScaleValue={minScaleValue}
              />
            </div>
            <div className='imagePreview'>
              <div className='zoomable'>
                <img
                  style={{
                    transform: 'scale(' + scaleValue + ')',
                  }}
                  id='imgDocument'
                  src={documentForPDFReview?.[page - 1]}
                />
              </div>
              {documentForPDFReview?.length > 0 && (
                <div className='pagination'>
                  <Pagination
                    onPageChange={(e, { activePage }) => {
                      setPage(activePage)
                    }}
                    activePage={page}
                    ellipsisItem={{ content: <Icon name='ellipsis horizontal' />, icon: true }}
                    firstItem={null}
                    lastItem={null}
                    prevItem={{ content: <Icon name='angle left' />, icon: true }}
                    nextItem={{ content: <Icon name='angle right' />, icon: true }}
                    totalPages={documentForPDFReview?.length}
                  />
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default React.memo(listOfDocuments)
